// src/components/filings/FilingLockedRow.jsx
import React from 'react';
import { categoryStyle, LOCK_COPY } from '../../data/filingFieldRegistry';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

function logLockCta(filing) {
  fetch(API_URL + '/api/filings/interaction', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ action: 'lock_cta', ticker: filing.ticker, filingCategory: filing.filingCategory, tier: filing.tier }),
  }).catch(() => {});
}

export default function FilingLockedRow({ filing, onSignIn }) {
  const style = categoryStyle(filing.filingCategory);
  const copy = LOCK_COPY[filing.lockReason] || LOCK_COPY.SIGN_IN_REQUIRED;

  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: '1rem', padding: '0.9rem 1.1rem',
      background: 'rgba(0,0,0,0.25)', border: '1px solid rgba(255,255,255,0.05)',
      borderRadius: '10px', marginBottom: '0.5rem', flexWrap: 'wrap',
    }}>
      <div style={{ width: 34, height: 34, borderRadius: '8px', flexShrink: 0,
        background: style.color + '0c', border: '1px solid rgba(255,255,255,0.08)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.95rem',
        filter: 'grayscale(0.6) opacity(0.6)' }}>
        🔒
      </div>

      <div style={{ flex: '1 1 220px', minWidth: 0 }}>
        <div style={{ fontSize: '0.9rem', fontWeight: 800, color: '#475569' }}>{filing.ticker}</div>
        <div style={{ fontSize: '0.72rem', color: '#374151', marginTop: '0.1rem' }}>
          {filing.companyName || filing.ticker}
        </div>
      </div>

      <div style={{ flex: '1 1 180px', fontSize: '0.82rem', color: '#4b5563', fontWeight: 600 }}>
        {filing.filingLabel}
      </div>

      <div style={{ fontSize: '0.72rem', color: '#374151', flex: '0 0 90px', textAlign: 'right' }}>
        {filing.filedAt}
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', flex: '0 0 auto' }}>
        <span style={{ fontSize: '0.72rem', color: '#64748b' }}>{copy.title}</span>
        {copy.actionable ? (
          <button onClick={() => { logLockCta(filing); onSignIn && onSignIn(); }}
            style={{ padding: '0.35rem 0.85rem', background: 'linear-gradient(135deg,#00ff88,#00d4ff)',
              border: 'none', borderRadius: '6px', color: '#050d1a', fontWeight: 800,
              cursor: 'pointer', fontSize: '0.75rem', fontFamily: 'inherit', whiteSpace: 'nowrap' }}>
            {copy.ctaLabel}
          </button>
        ) : (
          <span style={{ fontSize: '0.7rem', fontWeight: 700, color: '#a78bfa',
            background: 'rgba(167,139,250,0.1)', border: '1px solid rgba(167,139,250,0.25)',
            borderRadius: '20px', padding: '0.2rem 0.65rem', whiteSpace: 'nowrap' }}>
            Coming Soon
          </span>
        )}
      </div>
    </div>
  );
}
